// store/userActions.js
import { setUser, clearUser, setAuthInitializing } from "./userSlice";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { secureFetch } from "../data/secureFetch";

export const monitorAuthState = () => (dispatch) => {
  dispatch(setAuthInitializing(true));

  const auth = getAuth();

  const unsubscribe = onAuthStateChanged(auth, async (user) => {
    if (user) {
      try {
        // No longer send uid in body - backend will get it from Firebase token
        const response = await secureFetch(`/api/users`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          data: {}, // Empty body - uid comes from Authorization header
        });

        if (!response.ok) {
          throw new Error("Failed to fetch organization details");
        }

        const {
          first_name: firstName,
          last_name: lastName,
          email,
          organization_name: organizationName,
          organization_id: organizationId,
          stripe_connected_account_id,
          stripe_charges_enabled,
          stripe_payouts_enabled,
          stripe_account_status,
          stripe_requirements_pending_count,
          stripe_dashboard_attention_required,
          is_system_admin: isSystemAdmin,
          org_role: orgRole,
          memberships,
        } = response;

        // Check localStorage for active org preference
        const storedActiveOrgId = localStorage.getItem("activeOrgId");
        const activeOrgId = storedActiveOrgId
          ? parseInt(storedActiveOrgId, 10)
          : organizationId;

        dispatch(
          setUser({
            uid: user.uid,
            email,
            organizationId,
            organizationName,
            firstName,
            lastName,
            stripe_connected_account_id,
            stripe_charges_enabled,
            stripe_payouts_enabled,
            stripe_account_status,
            stripe_requirements_pending_count,
            stripe_dashboard_attention_required,
            isSystemAdmin: isSystemAdmin || false,
            orgRole: orgRole || null,
            memberships: memberships || [],
            activeOrgId: activeOrgId,
          })
        );
      } catch (error) {
        console.error("Failed to fetch organization details", error);
        dispatch(clearUser());
      }
    } else {
      dispatch(clearUser());
    }
    dispatch(setAuthInitializing(false));
  });

  return unsubscribe;
};

export const fetchUserData = () => async (dispatch) => {
  const auth = getAuth();
  const user = auth.currentUser;

  if (user) {
    try {
      // No longer send uid in body - backend will get it from Firebase token
      const response = await secureFetch(`/api/users`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: {}, // Empty body - uid comes from Authorization header
      });

      if (!response.ok) {
        throw new Error("Failed to fetch organization details");
      }

      const jsonResponse = response;

      const {
        first_name: firstName,
        last_name: lastName,
        email,
        organization_name: organizationName,
        organization_id: organizationId,
        stripe_connected_account_id,
        stripe_charges_enabled,
        stripe_payouts_enabled,
        stripe_account_status,
        stripe_requirements_pending_count,
        stripe_dashboard_attention_required,
        is_system_admin: isSystemAdmin,
        org_role: orgRole,
        memberships,
      } = jsonResponse;

      // Check localStorage for active org preference
      const storedActiveOrgId = localStorage.getItem("activeOrgId");
      const activeOrgId = storedActiveOrgId
        ? parseInt(storedActiveOrgId, 10)
        : organizationId;

      dispatch(
        setUser({
          uid: user.uid,
          email,
          organizationId,
          organizationName,
          firstName,
          lastName,
          stripe_connected_account_id,
          stripe_charges_enabled,
          stripe_payouts_enabled,
          stripe_account_status,
          stripe_requirements_pending_count,
          stripe_dashboard_attention_required,
          isSystemAdmin: isSystemAdmin || false,
          orgRole: orgRole || null,
          memberships: memberships || [],
          activeOrgId: activeOrgId,
        })
      );
    } catch (error) {
      console.error("Failed to fetch organization details", error);
      dispatch(clearUser());
    }
  } else {
    dispatch(clearUser());
  }
};
